import $ from "jquery";
import "css/highlights.sass";

$(function () {
  $(".highlights-button").hover(function () {
    $(".highlights-quote").hide();
    $("#" + $(this).attr("quote-id")).show();
  });
});
